(function () {
  var currencySymbol = String.fromCharCode(36);

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function formatMoney(cents) {
    return currencySymbol + (cents / 100).toFixed(2);
  }

  function initStickyAddToCart() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!location.pathname.includes('/products/')) return;
    if (document.querySelector('.mako-sticky-atc')) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var originalButton = form.querySelector('button[type="submit"], button[name="add"]');
    if (!originalButton) return;

    var bar = document.createElement('div');
    bar.className = 'mako-sticky-atc is-hidden';
    bar.innerHTML = '<span class="mako-sticky-atc__copy"><span class="mako-sticky-atc__title">Ready to personalize?</span><span class="mako-sticky-atc__meta">Free shipping ' + currencySymbol + '25+</span></span><button class="mako-sticky-atc__button" type="button">Add to Cart</button>';
    document.body.appendChild(bar);
    document.body.classList.add('mako-has-sticky-atc');

    bar.querySelector('button').addEventListener('click', function () {
      originalButton.click();
    });

    function syncDisabled() {
      bar.querySelector('button').disabled = originalButton.disabled;
    }
    syncDisabled();
    new MutationObserver(syncDisabled).observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var isVisible = entries.some(function (entry) { return entry.isIntersecting; });
        bar.classList.toggle('is-hidden', isVisible);
      }, { threshold: 0.2 });
      observer.observe(originalButton);
    } else {
      bar.classList.remove('is-hidden');
    }
  }

  async function initFreeShippingProgress() {
    var normalizedPath = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
    if (!normalizedPath.endsWith('/cart')) return;
    if (document.querySelector('.mako-free-shipping')) return;

    try {
      var response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      var cart = await response.json();
      if (!cart.item_count) return;

      var threshold = 2500;
      var remaining = Math.max(threshold - cart.total_price, 0);
      var progress = Math.min(Math.round((cart.total_price / threshold) * 100), 100);
      var message = remaining > 0
        ? 'You are ' + formatMoney(remaining) + ' away from free shipping.'
        : 'You unlocked free shipping.';

      var box = document.createElement('div');
      box.className = 'mako-free-shipping';
      box.style.setProperty('--mako-progress', progress + '%');
      box.innerHTML = '<p class="mako-free-shipping__text">' + message + '</p><div class="mako-free-shipping__bar" aria-hidden="true"><span class="mako-free-shipping__fill"></span></div>' + (remaining > 0 ? '<a class="mako-free-shipping__link" href="/collections/all">Add a charm bundle or 2-pack</a>' : '');

      var main = document.querySelector('#MainContent') || document.querySelector('main');
      var firstSection = main && main.querySelector('.section');
      (firstSection || main || document.body).prepend(box);
    } catch (error) {
      return;
    }
  }

  ready(function () {
    initStickyAddToCart();
    initFreeShippingProgress();
  });
})();
